/* @flow */

import * as React from 'react';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { get } from 'lodash/fp';
import glamorous from 'glamorous';
import { padding } from 'polished';

type Props = {
  children?: any,
  history: Object,
  referrer?: string
};

const defaultProps = {
  children: undefined,
  referrer: undefined
};

const Navigation = glamorous.div({
  alignItems: 'center',
  backgroundColor: 'white',
  display: 'flex'
});

const BackButton = glamorous.a(({ theme }) => ({
  color: theme.color.basis3,
  flexBasis: 'auto',
  flexGrow: 0,
  flexShrink: 0,
  fontSize: theme.fontSize.medium,
  lineHeight: 1,
  ...padding(0, theme.spacing.small)
}));

function NavBar({ children, history, referrer }: Props) {
  return (
    <Navigation>
      {referrer && (
        <BackButton onClick={history.goBack}>
          <span className="ion-ios-arrow-back" />
        </BackButton>
      )}
      {children}
    </Navigation>
  );
}

NavBar.defaultProps = defaultProps;

const enhancer = compose(
  withRouter,
  withProps(({ location }) => ({
    referrer: get('state.referrer', location)
  }))
);

export default enhancer(NavBar);
